import { default as CivicClerkLogo, CivicClerkLogoWhite, CivicClerkLogoCircle } from "./CivicClerk";
import { default as CivicEngageCentralLogo, CivicEngageCentralLogoWhite, CivicEngageCentralLogoCircle } from "./CivicEngageCentral";
import { default as CivicEngageEvolveLogo, CivicEngageEvolveLogoWhite, CivicEngageEvolveLogoCircle } from "./CivicEngageEvolve";
import { default as CivicHRLogo, CivicHRLogoWhite, CivicHRLogoCircle } from "./CivicHR";
import { default as CivicOptimizeLogo, CivicOptimizeLogoWhite, CivicOptimizeLogoCircle } from "./CivicOptimize";
import { default as CivicPlusLogo, CivicPlusLogoWhite, CivicPlusLogoCircle } from "./CivicPlus";
import { default as CivicReadyLogo, CivicReadyLogoWhite, CivicReadyLogoCircle } from "./CivicReady";
import { default as CivicRecLogo, CivicRecLogoWhite, CivicRecLogoCircle } from "./CivicRec";
import { default as CivicServiceLogo, CivicServiceLogoWhite } from "./CivicService";
import { default as SeeClickFixLogo, SeeClickFixLogoWhite, SeeClickFixLogoCircle } from "./SeeClickFix";
import { default as PreambleLogo, PreambleLogoWhite } from "./Preamble";
import React from "react";
export const Logo = ({
  product,
  white,
  circle,
  ...otherProps
}) => {
  if (product === "CivicClerk") {
    if (white) {
      return /*#__PURE__*/React.createElement(CivicClerkLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/React.createElement(CivicClerkLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/React.createElement(CivicClerkLogo, otherProps);
    }
  }
  if (product === "CivicEngage Evolve") {
    if (white) {
      return /*#__PURE__*/React.createElement(CivicEngageEvolveLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/React.createElement(CivicEngageEvolveLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/React.createElement(CivicEngageEvolveLogo, otherProps);
    }
  }
  if (product === "CivicEngage Central") {
    if (white) {
      return /*#__PURE__*/React.createElement(CivicEngageCentralLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/React.createElement(CivicEngageCentralLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/React.createElement(CivicEngageCentralLogo, otherProps);
    }
  }
  if (product === "CivicHR") {
    if (white) {
      return /*#__PURE__*/React.createElement(CivicHRLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/React.createElement(CivicHRLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/React.createElement(CivicHRLogo, otherProps);
    }
  }
  if (product === "CivicOptimize") {
    if (white) {
      return /*#__PURE__*/React.createElement(CivicOptimizeLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/React.createElement(CivicOptimizeLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/React.createElement(CivicOptimizeLogo, otherProps);
    }
  }
  if (product === "CivicReady") {
    if (white) {
      return /*#__PURE__*/React.createElement(CivicReadyLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/React.createElement(CivicReadyLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/React.createElement(CivicReadyLogo, otherProps);
    }
  }
  if (product === "CivicRec") {
    if (white) {
      return /*#__PURE__*/React.createElement(CivicRecLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/React.createElement(CivicRecLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/React.createElement(CivicRecLogo, otherProps);
    }
  }
  if (product === "CivicService") {
    if (white) {
      return /*#__PURE__*/React.createElement(CivicServiceLogoWhite, otherProps);
    } else if (!circle) {
      return /*#__PURE__*/React.createElement(CivicServiceLogo, otherProps);
    }
  }
  if (product === "SeeClickFix") {
    if (white) {
      return /*#__PURE__*/React.createElement(SeeClickFixLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/React.createElement(SeeClickFixLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/React.createElement(SeeClickFixLogo, otherProps);
    }
  }
  if (product === "Preamble") {
    if (white) {
      return /*#__PURE__*/React.createElement(PreambleLogoWhite, otherProps);
    } else if (!circle) {
      return /*#__PURE__*/React.createElement(PreambleLogo, otherProps);
    }
  }
  // CivicPlus logo as the default return.
  if (white) {
    return /*#__PURE__*/React.createElement(CivicPlusLogoWhite, otherProps);
  } else if (circle) {
    return /*#__PURE__*/React.createElement(CivicPlusLogoCircle, otherProps);
  } else {
    return /*#__PURE__*/React.createElement(CivicPlusLogo, otherProps);
  }
};
Logo.defaultProps = {
  role: "img",
  width: "100%",
  height: "100%"
};
export default Logo;